import { useState } from 'react'
import { Icon } from '../ui/Icon'
import { Sheet } from '../ui/Sheet'

/**
 * The branch sheet — pick, filter, or create. Split out of GitPanel.tsx in M6
 * (拆面板, 2026-09-03), moved verbatim; pure props, no transport of its own.
 */
export function BranchPicker({
  current,
  branches,
  loading,
  busy,
  onPick,
  onClose,
}: {
  current: string | null
  branches: string[]
  loading: boolean
  busy: boolean
  onPick: (branch: string, create: boolean) => void
  onClose: () => void
}) {
  const [q, setQ] = useState('')
  const needle = q.trim()
  const shown = branches.filter((b) => b.toLowerCase().includes(needle.toLowerCase()))
  // VS Code offers "Create new branch '<typed>'" whenever the text matches nothing.
  const canCreate = needle.length > 0 && !branches.includes(needle)

  return (
    <Sheet title="Checkout to…" onClose={onClose}>
      <input
        className="nas-input"
        type="search"
        placeholder="Branch name — type to filter or create"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        spellCheck={false}
        autoCapitalize="off"
        autoCorrect="off"
      />
      <div className="pk-list" role="listbox">
        {canCreate && (
          <button type="button" className="pk-row" disabled={busy} onClick={() => onPick(needle, true)}>
            <Icon name="add" size={15} />
            <span className="pk-label">Create new branch “{needle}”</span>
          </button>
        )}
        {loading && <div className="nas-note">loading branches…</div>}
        {!loading && shown.length === 0 && !canCreate && (
          <div className="nas-note">No branches match.</div>
        )}
        {shown.map((b) => (
          <button
            key={b}
            type="button"
            className={`pk-row${b === current ? ' on' : ''}`}
            disabled={busy || b === current}
            onClick={() => onPick(b, false)}
          >
            <Icon name={b === current ? 'check' : 'call_split'} size={15} />
            <span className="pk-label">{b}</span>
            {b === current && <span className="pk-sub">current</span>}
          </button>
        ))}
      </div>
    </Sheet>
  )
}

/* ── discard confirmation ─────────────────────────────────────────────────── */

/**
 * Discard is irreversible and does two different things depending on whether git is
 * tracking the file, so the prompt spells out which files get RESTORED and which get
 * DELETED. VS Code shows the same warning; the split matters more here because an
 * untracked file has no copy anywhere once it is gone.
 */
